export enum DomainDataType{
    DocumentType = "document-type",
    DocumentIssuing = "document-issuing",
    State = "state",
    City='city',
    Gender = "gender",
    Country='country',
    CountryNif='country-nif',
    Nationality='nationality',
    MaritalStatus='marital-status',
    OriginIncome='origin-income',
    Profession='profession',
    Empty='empty',
    Generic='generic'
    // CountryRes = 'country-res'
}
